import { z } from "zod/v4"

export const transactionFormSchema = z.object({
  date: z.coerce.date(),
  description: z.string().min(3, "Descrição deve ter no mínimo 3 caracteres"),
  type: z.enum(["income", "outcome"]),
  value: z.union([
    z.number().positive("Valor deve ser maior que zero"),
    z
      .string()
      .transform((val) => Number(val.replace(/\D+/g, "")))
      .pipe(z.number().positive("Valor deve ser maior que zero")),
  ]),
  isPaid: z.boolean().default(false),
  accountId: z.string().min(1, "Selecione uma conta"),
  categoryId: z.string().min(1, "Selecione uma categoria"),
  personId: z.string().optional(),
  comment: z.string().optional(),
  recurrence: z
    .enum([
      "yearly",
      "sixmonthly",
      "trimonthly",
      "bimonthly",
      "monthly",
      "biweekly",
      "weekly",
      "daily",
      "no-recurrence",
    ])
    .nullable()
    .optional(),
  recurrenceEndDate: z.coerce.date().nullable().optional(),
})

export const transferFormSchema = z
  .object({
    date: z.coerce.date(),
    value: z.union([
      z.number().positive("Valor deve ser maior que zero"),
      z
        .string()
        .transform((val) => Number(val.replace(/\D+/g, "")))
        .pipe(z.number().positive("Valor deve ser maior que zero")),
    ]),
    isPaid: z.boolean().default(false),
    fromAccountId: z.string().min(1, "Selecione a conta de origem"),
    toAccountId: z.string().min(1, "Selecione a conta de destino"),
  })
  .refine((data) => data.fromAccountId !== data.toAccountId, {
    message: "As contas devem ser diferentes",
    path: ["toAccountId"],
  })

export type TTransactionForm = z.infer<typeof transactionFormSchema>
export type TTransferForm = z.infer<typeof transferFormSchema>
